<input
  type="text"
  [class]="classes"
  [name]="elementId"
  [id]="elementId"
  [placeholder]="placeholder"
  [value]="searchTerm"
  autocomplete="off"
/>
